var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDrag = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 5,
  fill: "#343B4C"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.77 9.923H18.23M5.77 14.077H18.23",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgDrag;